"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ArchiveOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29 4H3a1 1 0 00-1 1v8a1 1 0 001 1h1v11a3 3 0 003 3h18a3 3 0 003-3V14h1a1 1 0 001-1V5a1 1 0 00-1-1zm-1 8H4V6h24zm-2 13a1 1 0 01-1 1H7a1 1 0 01-1-1V14h20z"/><path d="M13 21h6a3 3 0 003-3 1 1 0 00-2 0 1 1 0 01-1 1h-6a1 1 0 01-1-1 1 1 0 00-2 0 3 3 0 003 3z"/>';
var ArchiveOutlineSVG = function ArchiveOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.ArchiveOutlineSVG = ArchiveOutlineSVG;
ArchiveOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(ArchiveOutlineSVG);
exports.default = _default;